// Default dial code used when a booking phone number has no country code.
// `212` (Morocco) matches the default country ("MA") in the create-booking flow.
// Kept as a single constant so it can be changed without touching call sites.
export const DEFAULT_DIAL_CODE = "212";

// Normalize a free-text phone number into the digits-only international format
// that `wa.me` links require (no `+`, spaces, dashes, or leading `0`).
// Approach B: when the number carries no country code, the default dial code is
// prepended. A number already in international form (leading `+`/`00`, or already
// starting with the default dial code) keeps its country code.
export const normalizePhone = (raw: string): string => {
  const trimmed = raw.trim();
  const hadPlus = trimmed.startsWith("+");
  const digits = trimmed.replace(/\D/g, "");

  if (hadPlus) return digits;
  if (digits.startsWith("00")) return digits.slice(2);
  if (digits.startsWith("0")) return DEFAULT_DIAL_CODE + digits.slice(1);
  if (digits.startsWith(DEFAULT_DIAL_CODE)) return digits;
  return DEFAULT_DIAL_CODE + digits;
};

// Build a `wa.me` click-to-chat URL addressed to `phone` with a prefilled,
// URL-encoded `message`.
export const buildWhatsappUrl = (phone: string, message: string): string =>
  `https://wa.me/${normalizePhone(phone)}?text=${encodeURIComponent(message)}`;
